import React from 'react';

import { PropTypes } from 'prop-types';
import FileUpload from '@/shared/components/input/FileUpload';
import RichTextEditor from '@/shared/components/RichTextEditor';
import InlineAttachment from '@/shared/components/InlineAttachment';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import { FolderOpenIcon } from '@/shared/components/Icons';
import Button from '@/shared/components/Button';
import DatePicker from '@/shared/components/input/DatePicker';
import { isBeforeMinimum } from '@/shared/utils/validationHelpers';
import DocumentSelectorModal from './DocumentSelectorModal';
import { CanRead } from './security';

const messages = defineMessages({
  Subject: 'Subject',
  Attachments: 'Attachments',
  SendTo: 'To',
  Cc: 'CC',
  Bcc: 'BCC',
  Email: 'Email',
  ChooseDocumentInAdminPulse: 'Choose document in AdminPulse',
  DocumentDateLabel: 'Document date',
});

class EmailEditor extends React.Component {
  state = { showDocumentSelectorModal: false };

  render() {
    const {
      title,
      onTitleChanged,
      initialValue,
      onContentChanged,
      attachmentUploadEndpoint,
      intl,
      onAttachmentUploaded,
      attachments,
      onDeleteAttachment,
      initialRelation,
      documentDate,
      onDocumentDateChanged,
      id,
      isFreeEmail,
    } = this.props;
    const { showDocumentSelectorModal, dateFocused } = this.state;

    return (
      <div>
        {showDocumentSelectorModal && (
          <DocumentSelectorModal
            show
            initialRelation={initialRelation}
            onDocumentsSelected={documents => {
              this.setState({ showDocumentSelectorModal: false }, () =>
                documents.map(x => onAttachmentUploaded(null, x)),
              );
            }}
            onClose={() => this.setState({ showDocumentSelectorModal: false })}
          />
        )}
        <div className="form-group margin10T">
          <label className="control-label col-sm-3">{intl.formatMessage(messages.Subject)}</label>
          <div className="col-md-6">
            <input
              name="subject"
              required
              className="form-control "
              maxLength="500"
              value={title}
              onChange={e => onTitleChanged(e.target.value)}
            />
          </div>
        </div>
        {onDocumentDateChanged && (
          <div className="form-group margin10T">
            <label className="control-label col-sm-3">
              {intl.formatMessage(messages.DocumentDateLabel)}
            </label>

            <div className="col-md-6">
              <DatePicker
                placeholder={intl.formatMessage(messages.DocumentDateLabel)}
                date={documentDate}
                onDateChange={date => onDocumentDateChanged(date)}
                focused={dateFocused}
                onFocusChange={({ focused }) => this.setState({ dateFocused: focused })}
                id="documentDate"
                required
                block
                small
                isOutsideRange={isBeforeMinimum}
              />
            </div>
          </div>
        )}
        <div className="form-group">
          <label className="control-label col-sm-3">
            {intl.formatMessage(messages.Attachments)}
          </label>
          <div className="col-md-6">
            {attachments && (
              <div>
                {attachments.map(attachment => (
                  <InlineAttachment
                    key={attachment.id}
                    attachment={attachment}
                    onDelete={onDeleteAttachment}
                  />
                ))}
              </div>
            )}
            <React.Fragment>
              <div className="file-upload-wrapper">
                <FileUpload
                  relationId={initialRelation}
                  endpoint={attachmentUploadEndpoint}
                  onFileUploaded={(error, file) => onAttachmentUploaded(error, file)}
                  removeSuccessfullAfter={5000}
                />
              </div>
              <CanRead on="Documents">
                <Button
                  btnClassName="btn-block margin10T"
                  onClick={() => this.setState({ showDocumentSelectorModal: true })}
                >
                  <FolderOpenIcon className="margin5R" />
                  <FormattedMessage {...messages.ChooseDocumentInAdminPulse} />
                </Button>
              </CanRead>
            </React.Fragment>
          </div>
        </div>

        <RichTextEditor
          initialValue={initialValue}
          onChange={newContent => onContentChanged(newContent)}
          base64Images
          isFreeEmail={isFreeEmail}
          id={id}
        />
      </div>
    );
  }
}

EmailEditor.propTypes = {
  title: PropTypes.string,
  onTitleChanged: PropTypes.func.isRequired,
  initialValue: PropTypes.string,
  onContentChanged: PropTypes.func.isRequired,
  attachmentUploadEndpoint: PropTypes.string,
  intl: intlShape.isRequired,
  onAttachmentUploaded: PropTypes.func.isRequired,
  attachments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onDeleteAttachment: PropTypes.func,
  initialRelation: PropTypes.string,
  id: PropTypes.string,
};
EmailEditor.defaultProps = {
  title: '',
  attachmentUploadEndpoint: '',
  onDeleteAttachment: null,
  initialValue: '',
  initialRelation: undefined,
  id: 'default',
};
export default injectIntl(EmailEditor);
